
const CONTACTMANAGEMENT_CONSTANTS = {
    fieldMaxLengthValidationPrefix: "Maximum Length: ",
    fieldMinLengthValidationPrefix: "Minimum Length: ",
    numberValidationError: "Enter numbers only",
    fieldLengthValidationPrefix: "Allowed Length: ",

    /** PM-3452: footer under Notes when save is blocked until wrong phone value(s) change */
    wrongPhoneBlockFooterMessage:
        "Update is disabled until blocked number(s) are removed.",
};
  
  export default CONTACTMANAGEMENT_CONSTANTS;